import AboutIntro from './../components/sections/About/AboutIntro/AboutIntro';
import AboutStory from './../components/sections/About/AboutStory/AboutStory';
import AboutMissionVision from './../components/sections/About/AboutMissionVision/AboutMissionVision';
import AboutValues from './../components/sections/About/AboutValues/AboutValues';
import AboutCTA from './../components/sections/About/AboutCTA/AboutCTA';

const AboutPage = () => {
  return (
    <>
      <AboutIntro />
      <AboutStory />
      <AboutMissionVision />
      <AboutValues />
      <AboutCTA />
    </>
  );
};

export default AboutPage;